/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { JsonNode } from './jsonNode';
import { RuleTestFileView } from './ruleTestFileView';
import { RuleTestModuleTraceEntry } from './ruleTestModuleTraceEntry';
import { RuleTestProgress } from './ruleTestProgress';
import { RuleTestQuota } from './ruleTestQuota';

export interface RuleTestRunView { 
    runId?: string;
    status?: RuleTestRunView.StatusEnum;
    failureKind?: RuleTestRunView.FailureKindEnum;
    failureMessage?: string;
    rulesetType?: RuleTestRunView.RulesetTypeEnum;
    rulesetId?: string;
    ruleKey?: string;
    ruleLabel?: string;
    files?: Array<RuleTestFileView>;
    model?: string;
    editorDirty?: boolean;
    startedAt?: string;
    finishedAt?: string;
    durationMs?: number;
    progress?: RuleTestProgress;
    output?: JsonNode;
    moduleTrace?: Array<RuleTestModuleTraceEntry>;
    quota?: RuleTestQuota;
}
export namespace RuleTestRunView {
    export type StatusEnum = 'RUNNING' | 'COMPLETED' | 'FAILED';
    export const StatusEnum = {
        RUNNING: 'RUNNING' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum
    };
    export type FailureKindEnum = 'TIMEOUT' | 'MODULE_ERROR' | 'START_ERROR';
    export const FailureKindEnum = {
        TIMEOUT: 'TIMEOUT' as FailureKindEnum,
        MODULEERROR: 'MODULE_ERROR' as FailureKindEnum,
        STARTERROR: 'START_ERROR' as FailureKindEnum
    };
    export type RulesetTypeEnum = 'KI' | 'HYBRID' | 'CROSS' | 'IDS';
    export const RulesetTypeEnum = {
        KI: 'KI' as RulesetTypeEnum,
        HYBRID: 'HYBRID' as RulesetTypeEnum,
        CROSS: 'CROSS' as RulesetTypeEnum,
        IDS: 'IDS' as RulesetTypeEnum
    };
}